import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-choice-with-opinion',
  templateUrl: './choice-with-opinion.component.html',
  styleUrls: ['./choice-with-opinion.component.css'],
})
export class ChoiceWithOpinionComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string | { choice: string; other: string };
  }>();

  selectedValue: string | null = null;
  opinionText: string = '';
  selectedIsCorrect: boolean = false;

  handleSelection(answerUuid: string, isCorrect: boolean): void {
    this.selectedValue = answerUuid;
    this.selectedIsCorrect = isCorrect;

    if (!isCorrect) {
      this.opinionText = '';
    }

    this.emitAnswer();
  }

  emitAnswer(): void {
    const answerPayload =
      this.selectedIsCorrect && this.opinionText
        ? { choice: this.selectedValue!, other: this.opinionText }
        : this.selectedValue!;

    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: answerPayload,
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
